import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'female-pr',
	landing: {
		ids: ['loader-f'],
		route: {
			path: '/f-pr',
			name: 'female-pr-funnel',
		},
	},
	funnel: {
		id: 'ob-female-pr-funnel',
		route: {
			path: '/f-pr/ob/:page(.*)?',
			name: 'female-pr',
		},
		slug: 'female-pr',
		theme: 'light',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-f-pr',
	},
	upsell: {
		routeNames: ['upsell-static-subscription-activated', 'upsell-f'],
	},
	upgrade: {
		routeName: null,
	},
}

export default appAreaConfig
